export default {
  name: 'LoginIndex'
}
